import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChartTileDisplayPreferenceService {
  private readonly reportsShowGridFirstStorageKey = 'pilexos.reports.showGridFirst';

  getReportsShowGridFirst(): boolean {
    const storedValue = localStorage.getItem(this.reportsShowGridFirstStorageKey);

    return storedValue === 'true';
  }

  setReportsShowGridFirst(showGridFirst: boolean): void {
    localStorage.setItem(this.reportsShowGridFirstStorageKey, String(showGridFirst));
  }
}
